import styled from 'styled-components';
import {
  Table as SemanticTable,
} from 'semantic-ui-react';

export const Header = styled(SemanticTable.HeaderCell)`
  &&&& {
    width: 100px;
    z-index: 5;
    position: sticky;
    color: ${(props) => props.theme.color.textHeader};
    top: 0;
    font-size: 14px;
    font-weight: 500;
    background-color: ${(props) => props.theme.color.white};
    ${(props) => (props.isMerged) && (
      `border-bottom: 5px solid ${props.theme.color.primary}`)};
  }
`;
